import create from "zustand";
import {Directions, Speeds} from "../utils/constants";

interface AppState {
    isDragging: boolean;
    deltaX: number;
    deltaY: number;
    scrollSpeed: Speeds;
    speedThresholds: number[];
    speedThrottles: number[];
    scrollDirection: Directions;
}

const useJoystickStore = create<AppState>((set, get) => ({
    isDragging: false,
    deltaX: 0,
    deltaY: 0,
    scrollSpeed: Speeds.SLOW,
    speedThresholds: [20, 40, 50],
    speedThrottles: [500, 350, 150, 50],
    scrollDirection: Directions.NEUTRAL,
}));

export default useJoystickStore;